/* eslint-disable @typescript-eslint/no-explicit-any */
import { Utils } from "@h4x/common";
import { floatManager } from "./utils.svelte.js";
export function float(element, options) {
    const parentElement = element;
    parentElement.id = !parentElement.id ? Utils.generateHID() : parentElement.id;
    const id = options.id ?? Utils.generateHID();
    if (options.toggle) {
        const activeLayer = floatManager.getLayerFromID(id);
        if (activeLayer) {
            floatManager.closeFloatElementByLayer(activeLayer);
            return;
        }
    }
    floatManager.addFloatElement(`layer_${options.layer ?? 1}`, {
        ...options,
        offsetX: options.offsetX ?? 0,
        offsetY: options.offsetY ?? 0,
        position: options.position ?? "bottom-right",
        layer: options.layer ?? 1,
        parentElementId: parentElement.id,
        id,
        type: "dynamic",
    });
}
export function staticFloat(options) {
    const id = options.id ?? Utils.generateHID();
    floatManager.addFloatElement(`layer_${options.layer ?? 1}`, {
        ...options,
        layer: options.layer ?? 1,
        id,
        type: "static",
    });
}
export const HEUI_FLOAT_ID_KEY = "HEUI:FloatID";
